import React from 'react';
import {Space} from 'antd';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {
  StyledInvoiceSnippet,
  StyledInvoiceSnippetContent,
  StyledInvoiceSnippetContentTitle,
  StyledInvoiceSnippetContentValue
} from './StyledInvoiceSnippet';
import ImagePreviewTooltip from '../../TransactionsPage/ImagePreviewTooltip';
import {amountHelpers, dateHelpers, invoicesHelpers, textHelpers} from '../../../../utils/helpers';
import routes from '../../../../routes/routes.json';
import {invoicePaymentStatusConstants} from '../../../../constants';
import useInvoiceAttachmentPreview from '../../../../hooks/useInvoiceAttachmentPreview';
import invoicePlaceholderImg from '../../../../static/images/pages/transactions/invoice-placeholder.png';

const getDate = (value) => value ? dateHelpers.getDateWithMonth(value) : '-';

const InvoiceSnippet = ({
  invoice,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const {
    showPreview,
    tooltipContent
  } = useInvoiceAttachmentPreview();

  const amount = invoice?.amount;

  const paymentStatus = invoice?.payment_status;

  const isOverdue = paymentStatus === invoicePaymentStatusConstants.OVERDUE;

  return (
    <StyledInvoiceSnippet {...rest}>
      <ImagePreviewTooltip
        classNames={{root: 'image-preview-tooltip-overlay vendor-details'}}
        title={tooltipContent}
      >
        <Space onMouseEnter={() => showPreview(invoice.id)}>
          <img
            alt='invoice preview'
            className='placeholder'
            src={invoicePlaceholderImg}
          />
          <StyledInvoiceSnippetContent>
            <StyledInvoiceSnippetContentTitle>
              {t('invoice')} {t('date')}
            </StyledInvoiceSnippetContentTitle>
            <StyledInvoiceSnippetContentValue>
              {getDate(invoice?.date)}
            </StyledInvoiceSnippetContentValue>
          </StyledInvoiceSnippetContent>
          <StyledInvoiceSnippetContent>
            <StyledInvoiceSnippetContentTitle>
              {t('due')} {t('date')}
            </StyledInvoiceSnippetContentTitle>
            <StyledInvoiceSnippetContentValue>
              {getDate(invoice?.due_date)}
            </StyledInvoiceSnippetContentValue>
          </StyledInvoiceSnippetContent>
          <StyledInvoiceSnippetContent>
            <StyledInvoiceSnippetContentTitle danger={isOverdue}>
              {invoicesHelpers.getInvoiceStatusMark(paymentStatus) || '-'}
              <span className='amount'>
                {amount ? amountHelpers.getAmountWithCurrencyCode(amount, undefined, invoice?.currency) : ''}
              </span>
            </StyledInvoiceSnippetContentTitle>
            <StyledInvoiceSnippetContentValue>
              {textHelpers.cutString(invoice?.uploaded_by, 40)}
            </StyledInvoiceSnippetContentValue>
          </StyledInvoiceSnippetContent>
        </Space>
      </ImagePreviewTooltip>

      <Link to={`${routes.invoicesList}/${invoice.id}`}>
        {invoicesHelpers.getInvoiceMatchType(invoice)}
      </Link>
    </StyledInvoiceSnippet>
  );
}

InvoiceSnippet.propTypes = {
  invoice: PropTypes.shape({
    currency: PropTypes.string,
    date: PropTypes.string,
    due_date: PropTypes.string,
    id: PropTypes.string,
    payment_status: PropTypes.string,
    uploaded_by: PropTypes.string
  })
}

export default InvoiceSnippet;
